const groupingsFilters = [
  {
    name: 'id',
    label: 'grouping',
    type: 'text',
    whereOperator: '=',
  },
];

export default groupingsFilters;
